import http from '@/utils/request';

/**
 * 应收单交易凭证
 *
 * @param {*} data
 * @returns
*/
export const getReceiveTradeVoucher = (data = {}) => {
  const url = '/receipt/receive/tradeVoucher';
  return http.post({
    url,
    data,
  });
};

/**
 * 收款单交易凭证查询
 *
 * @param {*} data
 * @returns
*/
export const getReceiptVoucher = (data = {}) => {
  const url = '/receipt/receipt/receiptVoucher';
  return http.post({
    url,
    data,
  });
};

/**
 * 应付单列表
 *
 * @param {*} data
 * @returns
*/
export const getPaymentPayableList = (data = {}) => {
  const url = '/payment/payable/bopList';
  return http.post({
    url,
    data,
  });
};

/** ****付款单***** */

/**
 * 付款单列表
 *
 * @param {*} data
 * @returns
*/
export const getPaymentPaymentList = (data = {}) => {
  const url = '/payment/payment/bopList';
  return http.post({
    url,
    data,
  });
};
/**
 * 付款单列表-付款单详情
 *
 * @param {*} data
 * @returns
*/
export const getPaymentPaymentDetail = (data = {}) => {
  const url = '/payment/payment/detail';
  return http.post({
    url,
    data,
  });
};

// 付款单列表-付款单详情 ==> 关联的应付单列表
export const getPayablePaymentList = (data = {}) => {
  const url = '/payment/payablePayment/page';
  return http.post({
    url,
    data,
  });
};

/**
 * 付款单列表-发起付款-获取付款方式
 *
 * @param {*} data
 * @returns
*/
export const getPaymentPaymentPayMethod = (data = {}) => {
  const url = '/payment/payment/getPayMethod';
  return http.post({
    url,
    data,
  });
};

/**
 * 付款单列表-发起付款-短信验证码发送
 *
 * @param {*} data
 * @returns
*/
export const setPaymentPaymentSendPayCode = (data = {}) => {
  const url = '/payment/payment/sendPayCode';
  return http.post({
    url,
    data,
  });
};
/**
 * 付款单列表-发起付款-出款
 *
 * @param {*} data
 * @returns
*/
export const setPaymentPaymentOnline = (data = {}) => {
  const url = '/payment/payment/payOnlineSubmit';
  return http.post({
    url,
    data,
  });
};
/**
 * 付款单列表-发起付款-线下付款
 *
 * @param {*} data
 * @returns
*/
export const setPaymentPaymentOffline = (data = {}) => {
  const url = '/payment/payment/payOfflineSubmit';
  return http.post({
    url,
    data,
  });
};

// 修改客户收款名称
export const modifyAccountName = (data = {}) => {
  const url = '/payment/payment/modifyAccountName';
  return http.post({
    url,
    data,
  });
};

// 查询付款单信息（客户收款名称）
export const queryPaymentDetail = (data = {}) => {
  const url = '/payment/payment/queryPaymentDetail';
  return http.post({
    url,
    data,
  });
};


/**
 * 批量付款-获取付款方式
*/
export const getBatchPayMethod = (data = {}) => {
  const url = '/payment/payment/getBatchPayMethod';
  return http.post({
    url,
    data,
  });
};

/**
 * 批量付款-目标账户信息
*/
export const getBatchAccInfo = (data = {}) => {
  const url = '/payment/payment/batchAccInfo';
  return http.post({
    url,
    data,
  });
};

/**
 * 批量付款-线上付款
*/
export const batchPayOnlineSubmit = (data = {}) => {
  const url = '/payment/payment/batchPayOnlineSubmit';
  return http.post({
    url,
    data,
  });
};

// 取消付款
export const cancelPayment = (data = {}) => {
  const url = '/payment/payment/cancel';
  return http.post({
    url,
    data,
  });
};

// 先收后付的二次控制
export const payCommitCheck = (data = {}) => {
  const url = '/payment/payment/payCommitCheck';
  return http.post({
    url,
    data,
  });
};

// 获取账户列表
export const getBakAcctList = (data = {}) => {
  return http.post({
    url: '/receipt/cashier/bakAcctList',
    data,
  });
};

// 关联抵款明细
export const getRelateDeductDetail = (data) => {
  return http.post({
    url: '/payment/payment/relateDeductOrderDetail',
    data,
  });
};
// 实时查询余额
export const getRealTimeBalance = (data = {}) => {
  const url = '/payment/payment/getRealTimeBalance';
  return http.post({
    url,
    data,
  });
};
